module.exports = __webpack_public_path__ + "static/img/logo-iata.636f5feb.png";